import React, { createContext, useState, ReactNode, useCallback } from "react";

interface EditModeContextType {
  editMode: boolean;
  toggleEditMode: () => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export const EditModeContext = createContext<EditModeContextType>({
  editMode: false,
  toggleEditMode: () => {},
});

interface EditModeProviderProps {
  children: ReactNode;
}

export const EditModeProvider: React.FC<EditModeProviderProps> = ({
  children,
}) => {
  const [editMode, setEditMode] = useState<boolean>((): boolean => {
    const savedEditMode = localStorage.getItem("editMode");
    const savedEditModeTimestamp = localStorage.getItem("editModeTimestamp");

    // true if edit mode is enabled and the timestamp is less than 1 day ago
    return savedEditMode === "true" && savedEditModeTimestamp
      ? new Date(savedEditModeTimestamp) >
          new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
      : false;
  });

  const toggleEditMode = useCallback(() => {
    const newEditMode = !editMode;

    setEditMode(newEditMode);
    localStorage.setItem("editMode", newEditMode ? "true" : "false");
    localStorage.setItem("editModeTimestamp", new Date().toISOString());
  }, [editMode]);

  return (
    <EditModeContext.Provider value={{ editMode, toggleEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
};
